import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { Masthead } from './components/Masthead/Masthead';
import { Footer } from './components/Footer/Footer';
import { loadMeta } from './data/loaders';
import type { Meta } from './data/types';

export interface RootData {
  meta: Meta;
}

export async function rootLoader(): Promise<RootData> {
  const meta = await loadMeta();
  return { meta };
}

export function SiteShell() {
  return (
    <div className="page">
      <a className="skip-link" href="#main">Skip to content</a>
      <Masthead />
      <main id="main" style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
      <Analytics />
    </div>
  );
}
